import { render } from "./BgpPeersTab.vue?vue&type=template&id=0654f42c&scoped=true"
import script from "./BgpPeersTab.vue?vue&type=script&lang=js"
export * from "./BgpPeersTab.vue?vue&type=script&lang=js"

import "./BgpPeersTab.vue?vue&type=style&index=0&id=0654f42c&lang=scss&scoped=true"

import exportComponent from "/opt/novus-cloud-ui/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0654f42c"]])

export default __exports__